import styled from 'styled-components';

export const UiSessionReport = styled.div`
display: block;
padding: 48px 32px;
`;

export const UiActionWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 50px;
`;

export const UiActionContainer = styled.div`
	display: flex;
	align-items: center;
	color: #8B90A0;
`;

export const UiPreviousPageButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	font-size: 1rem;
	font-weight: 500;
	color: #8B90A0;
`;

export const UiSessionEmpty = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

export const UiEmptyImg = styled.div`
	width: 29%;
	height: 207px;
	background: url("${({ path }) => path}");
	background-position: center;
	background-size: cover;
	margin-bottom: 25px;
`;